var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveCalls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#5222ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-340 -1600)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(340 1601)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.332 1454.99)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.672,283.906a3.952,3.952,0,0,0-2.807-1.147A4.194,4.194,0,0,0,178.884,284l-3.27,3.267-.388-.216a32.517,32.517,0,0,1-14.41-14.411l-.207-.376,3.272-3.27a4.1,4.1,0,0,0,.094-5.79l-6.982-6.983a3.94,3.94,0,0,0-2.806-1.149,4.2,4.2,0,0,0-2.984,1.246l-1.967,1.979a.462.462,0,0,0-.134.293,11.856,11.856,0,0,0-1.538,2.783,12.324,12.324,0,0,0-.749,3.01c-.942,7.8,2.588,14.9,12.181,24.489,11.351,11.352,20.943,12.234,23.613,12.234a8.6,8.6,0,0,0,.886-.038,12.309,12.309,0,0,0,3.022-.76,11.781,11.781,0,0,0,2.794-1.549.455.455,0,0,0,.254-.127l2-1.957a4.108,4.108,0,0,0,.092-5.791Zm6.235,12.116-1.834,1.8a.469.469,0,0,0-.164.083,10.806,10.806,0,0,1-2.731,1.547,11.382,11.382,0,0,1-2.788.7,7.823,7.823,0,0,1-.782.032c-2.579,0-11.857-.863-22.957-11.962-9.366-9.366-12.817-16.238-11.914-23.724a11.381,11.381,0,0,1,.692-2.784,10.843,10.843,0,0,1,1.554-2.742.469.469,0,0,0,.09-.194l1.787-1.8a3.273,3.273,0,0,1,2.326-.973,3.017,3.017,0,0,1,2.15.876l6.981,6.983a3.173,3.173,0,0,1-.093,4.477l-3.521,3.519a.464.464,0,0,0-.075.559c.122.214.245.438.385.69a33.418,33.418,0,0,0,14.761,14.757l.7.387a.464.464,0,0,0,.552-.079l3.518-3.516a3.27,3.27,0,0,1,2.325-.972,3.026,3.026,0,0,1,2.151.875L191,291.547a3.177,3.177,0,0,1-.09,4.475Z",
    transform: "translate(0 -95.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M236.033,145.01a28.624,28.624,0,0,0-22.414,10.751.464.464,0,0,0,.724.582,27.809,27.809,0,1,1,39.1,39.088.465.465,0,0,0,.583.725,28.737,28.737,0,0,0-17.994-51.145Z",
    transform: "translate(-58.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.527,277.2h-22.6a.464.464,0,0,0,0,.929h22.6a.464.464,0,0,0,0-.929Z",
    transform: "translate(-150.189 -114.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M387.757,317.764a.465.465,0,0,0-.464-.464H363.363a.464.464,0,0,0,0,.929h23.929A.464.464,0,0,0,387.757,317.764Z",
    transform: "translate(-187.945 -149.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M319.924,358.317H338.39a.464.464,0,1,0,0-.929H319.924a.464.464,0,1,0,0,.929Z",
    transform: "translate(-150.189 -184.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.074,397.48a.464.464,0,0,0,0,.929h17.865a.464.464,0,0,0,0-.929Z",
    transform: "translate(-173.787 -219.444)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCalls);
export default __webpack_public_path__ + "static/media/liveCalls.0059ad4b107b06ff47592bdd7240dac7.svg";
export { ForwardRef as ReactComponent };